import React from 'react';

// Veines partant des bords, en % de l'écran (le trait garde son épaisseur grâce à non-scaling-stroke)
const VEINS = [
  // gauche
  'M0 34 C 5 35, 8 40, 13 39 S 20 44, 25 42',
  'M8 39 C 9 44, 8 48, 12 52',
  'M0 68 C 4 66, 7 70, 11 67 S 16 62, 21 64',
  // droite
  'M100 28 C 95 30, 93 25, 88 27 S 81 33, 76 31',
  'M93 27 C 91 22, 92 18, 88 14',
  'M100 62 C 96 63, 93 68, 88 66 S 82 71, 78 70',
  'M92 66 C 91 71, 93 75, 90 79',
  // haut
  'M18 0 C 19 4, 23 6, 22 10 S 26 15, 25 19',
  'M78 0 C 77 5, 73 7, 74 11',
  // bas
  'M30 100 C 31 96, 27 93, 29 89 S 25 83, 27 79',
  'M70 100 C 69 95, 73 92, 71 88',
];

/**
 * Coup de sang : des veines rouges se dessinent depuis les bords puis s'estompent.
 * Rejoué à chaque changement de `key` ; purement décoratif.
 */
const VtmBloodSurgeVeins = () => (
  <svg className="vtmSurgeVeins" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
    {VEINS.map((d, index) => (
      <path key={d} d={d} pathLength="1" vectorEffect="non-scaling-stroke" style={{animationDelay: `${(index % 4) * 70}ms`}} />
    ))}
  </svg>
);

export default VtmBloodSurgeVeins;
